"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.36,6.88H16.63V.69a.69.69,0,0,0-1.39,0V6.88H8.76V.69a.69.69,0,0,0-1.39,0V6.88H3.64a.69.69,0,0,0,0,1.39H5.41v6.19A4.62,4.62,0,0,0,9.34,19v2.33A.69.69,0,0,0,10,22h1.27v1.27a.69.69,0,0,0,1.39,0V22H14a.69.69,0,0,0,.69-.69V19a4.62,4.62,0,0,0,3.93-4.56V8.27h1.76a.69.69,0,0,0,0-1.39Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;